import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { reportsPageDef } from '@/components/scm/scm-page-defs';

export default function ScmReportsPage() {
  return <ScmPageRenderer pageDef={reportsPageDef} />;
}
